<script setup lang="ts">
import type {InfoCardItem} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import {resolveRelation, resolveMediaUrl} from '~/utils/relations'

const props = defineProps<{
  card: Populated<InfoCardItem>
}>()
</script>

<template>
  <div
    v-if="!props.card.video"
    :class="[
      'relative z-50 mt-10 flex w-full cursor-pointer flex-row items-start items-center gap-6 rounded-lg border-main-300 p-2 transition-all duration-300 ease-in-out hover:bg-main-50 hover:shadow-[0_0_0_2px_#2AAEA3] lg:w-1/2 lg:p-8',
      resolveMediaUrl(props.card.video) ? '' : 'border',
      Number(props.card.number) % 2 === 0 ? 'md:rotate-[-2deg]' : 'md:rotate-[2deg]',
    ]"
  >
    <span
      v-if="!props.card.video"
      class="hidden h-10 w-10 items-center justify-start rounded-full bg-main-100 p-4 text-lg font-bold text-main-700 md:flex"
    >
      {{ props.card.number }}
    </span>
    <RichText class="text-md" :raw="props.card.body" />

    <NuxtLink to="/product-discovery-workshop" v-if="props.card.link">
      <span
        class="group absolute bottom-0 right-10 flex cursor-pointer items-center py-3 text-sm text-main-800 lg:bottom-0"
      >
        {{ $t('home.projects.more') }}
        <Icon name="lucide:move-right" size="18" class="ml-2 transition group-hover:translate-x-1" />
      </span>
    </NuxtLink>
  </div>

  <div class="mt-8 flex items-center justify-center">
    <video
      class="w-[900px] rounded-lg border border-gray-200 bg-white p-3 lg:rotate-[-2deg]"
      v-if="resolveMediaUrl(props.card.video)"
      :src="resolveMediaUrl(props.card.video)"
      controls
    ></video>
  </div>
</template>
